import axios from 'axios';
import { envConfig } from '../utils/enviroment';

export const catalogoApi = axios.create({
  baseURL: process.env.REACT_APP_CATALOGO_API
});

export const slotsApi = axios.create({
  baseURL: process.env.REACT_APP_SLOTS_API,
  headers: {
    'x-app-name': envConfig.REACT_APP_X_APP_NAME ?? ''
  }
});

export const ViaCepApi = axios.create({
  baseURL: process.env.REACT_APP_VIACEP_API
});

export const BusnessRule = axios.create({
  baseURL: process.env.REACT_APP_BUSINESS_RULE,
  headers: {
    'x-app-name': envConfig.REACT_APP_X_APP_NAME ?? ''
  }
});

export const ScheduleSpecialistApi = axios.create({
  baseURL: process.env.REACT_APP_SCHEDULE_SPECIALIST_API,
  headers: {
    'x-app-name': envConfig.REACT_APP_X_APP_NAME ?? ''
  }
});

export const mockServeApi = axios.create({
  baseURL: 'http://localhost:4444'
});

export const specialistsApi = axios.create({
  baseURL: process.env.REACT_APP_SPECIALISTS_PUBLIC_API,
  headers: {
    'X-Tenant-Id': 'einstein',
    'x-app-name': envConfig.REACT_APP_X_APP_NAME ?? ''
  }
});

export const specialistsApiV2 = axios.create({
  baseURL: process.env.REACT_APP_SPECIALISTS_PUBLIC_API
});

export const unifiedAppointmentsApi = axios.create({
  baseURL: process.env.REACT_APP_UNIFIED_APPOINTMENTS,
  headers: {
    'X-Tenant-Id': 'einstein',
    'x-app-name': envConfig.REACT_APP_X_APP_NAME ?? ''
  }
});

export const teleorientationApi = axios.create({
  baseURL: process.env.REACT_APP_TELEORIENTATION_BASE_URL
});

export const lambdaValidateApi = axios.create({
  baseURL: process.env.REACT_APP_GET_LAMBDA_VALIDATE_API_URL
});

export const uploadFileApi = axios.create({
  baseURL: process.env.REACT_APP_UPLOAD_FILE
});

export const AppointmentBookApi = axios.create({
  baseURL: process.env.REACT_APP_APPOINTMENT_BOOK_API,
  headers: {
    'x-app-name': envConfig.REACT_APP_X_APP_NAME ?? ''
  }
});
